import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon-close',
  templateUrl: './icon-close.component.html',
  styleUrls: ['./icon-close.component.scss'],
  standalone: true,
})
export class IconCloseComponent {
  @Input() color = '#fff';
  @Input() width = '24';
  @Input() height = '24';
}
